module.exports = __webpack_public_path__ + "static/img/swiper2.da9dbcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/swiper2.jpg
// module id = Wg3n
// module chunks = 0